import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import AdvisoryHero from "./components/AdvisoryHero";
import AdvisoryOverview from "./components/AdvisoryOverview";
import WhoAdvisoryIsFor from "./components/WhoAdvisoryIsFor";
import CoreAdvisoryAreas from "./components/CoreAdvisoryAreas";
import HowHarambeeWorks from "./components/HowHarambeeWorks";
import WhyChooseHarambee from "./components/WhyChooseHarambee";
import AdvisoryProcess from "./components/AdvisoryProcess";
import AdvisoryOutcomes from "./components/AdvisoryOutcomes";
import AdvisoryFAQ from "./components/AdvisoryFAQ";
import AdvisoryConsultForm from "./components/AdvisoryConsultForm";

export default function AdvisoryPage() {
  return (
    <div className="min-h-screen bg-white font-['Inter']">
      <Navbar />
      <main>
        <AdvisoryHero />
        <AdvisoryOverview />
        <WhoAdvisoryIsFor />
        <CoreAdvisoryAreas />
        <HowHarambeeWorks />
        <WhyChooseHarambee />
        <AdvisoryProcess />
        <AdvisoryOutcomes />
        <AdvisoryFAQ />
        <AdvisoryConsultForm />
      </main>
      <Footer />
    </div>
  );
}
